import { call, put, takeLatest, select } from "redux-saga/effects";
import { inquiryActions } from "./inquirySlice";
import inquiryApi from "api/inquiry";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

function* getInquiryDataRequest(action: PayloadAction<any>): Generator<any, any, any> {
  try {
    const response: any = yield call(inquiryApi.getInquiryData, action.payload);
    const data = response.data;
    if (data.success) {
      yield put(inquiryActions.getInquiryDataSuccess(data));
    } else {
      yield put(inquiryActions.getInquiryDataFailed(data.message || "Failed to fetch data"));
    }
  } catch (error: any) {
    const errorData = error.response?.data || { message: error.message };
    yield put(inquiryActions.getInquiryDataFailed(errorData.message || "An error occurred"));
  }
}

function* updateInquiryStatusRequest(action: PayloadAction<any>): Generator<any, any, any> {
  try {
    const response: any = yield call(inquiryApi.updateInquiryStatus, action.payload);
    const data = response.data;
    if (data.success) {
      toast.success(data.message || `Inquiry ${action.payload.status}ed successfully`);
      yield put(inquiryActions.updateInquiryStatusSuccess(data));
      // Refresh the list after successful update
      // We need the current page and limit from the state if we want to stay on the same page
      // For now, let's just trigger a reload with default or common values if possible, 
      // or we can assume the component will handle it if it's listening to success.
      // Actually, it's better to stay on the current page.
      yield put(inquiryActions.getInquiryDataRequest({ page: 1, limit: 6 })); 
    } else {
      toast.error(data.message || "Failed to update status");
      yield put(inquiryActions.updateInquiryStatusFailed(data.message || "Failed to update status"));
    }
  } catch (error: any) {
    const errorData = error.response?.data || { message: error.message };
    toast.error(errorData.message || "An error occurred");
    yield put(inquiryActions.updateInquiryStatusFailed(errorData.message || "An error occurred"));
  }
}

export default function* inquirySaga() {
  yield takeLatest(inquiryActions.getInquiryDataRequest.type, getInquiryDataRequest);
  yield takeLatest(inquiryActions.updateInquiryStatusRequest.type, updateInquiryStatusRequest);
}
